import { render, staticRenderFns } from "./Doubts.vue?vue&type=template&id=83314174&"
import script from "./Doubts.vue?vue&type=script&lang=js&"
export * from "./Doubts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports